import { apolloClient } from '@/plugins/apollo';
import {
  CreateDataExtractionField,
  UpdateDataExtractionField,
} from '@/graphql';
import { createDataExtractionFieldInput } from '@/models/DataExtractionField';

const actions = {
  async createDataExtractionField(context, { reviewId, field }) {
    const fieldInputData = createDataExtractionFieldInput(field);
    const response = await apolloClient.mutate({
      mutation: CreateDataExtractionField,
      variables: {
        review: reviewId,
        dataExtractionField: fieldInputData,
      },
    });

    return response.data.createDataExtractionField;
  },
  async updateDataExtractionField(context, { field }) {
    const fieldInputData = createDataExtractionFieldInput(field);

    const response = await apolloClient.mutate({
      mutation: UpdateDataExtractionField,
      variables: {
        id: field.id,
        dataExtractionField: fieldInputData,
      },
    });

    return response.data.updateDataExtractionField;
  },
};

export default {
  namespaced: true,
  actions,
};
